import { render, staticRenderFns } from "./BarsByAge.vue?vue&type=template&id=2fa2eab4&scoped=true&"
import script from "./BarsByAge.vue?vue&type=script&lang=js&"
export * from "./BarsByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2eab4",
  null
  
)

export default component.exports